/**
 * 帮助中心
 */
import { HELPCENTER } from '../types';

export default {
    name: `${HELPCENTER}`,
    path: '/helpCenter',
    component: () => import(/* webpackChunkName: 'helpCenter' */ '@/views/helpCenter/'),
    redirect: { name: `${HELPCENTER}Index` },
    meta: {
        title: '帮助中心',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${HELPCENTER}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'helpCenter' */ '@/views/helpCenter/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${HELPCENTER}Search`,
            path: 'search',
            component: () => import(/* webpackChunkName: 'helpCenter' */ '@/views/helpCenter/search/Search.vue'),
        },
        {
            name: `${HELPCENTER}Column`,
            path: 'column',
            component: () => import(/* webpackChunkName: 'helpCenter' */ '@/views/helpCenter/column/Column.vue'),
        },
    ],
};
